export default "__VITE_ASSET__DPx3cyuA__"